/*
*@/components/cat4mro/mro-invite-to-rfq
*/
export default {
  MroInviteToRfq: {
    p1: 'Su empresa no tiene activado',
    p2: 'el módulo de cotizaciones',
    p3: 'Favor contactar a',
    email: 'ventas@unilinkcorp.com',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/buyer/cat4mro/components/mroInviteToRfq.js